// @flow
import React from "react";
import withStyles from "elevate-ui/withStyles";
import { withGlobalContext } from "../common/GlobalContext";
import Color from "color";

import RenderLink from "./RenderLink";

type $Props = {
  classes: Object,
  item: Object,
  idx: number,
  openDropdowns: Function,
};

const RenderNavItem = ({ classes, item, idx, openDropdowns }: $Props) => {
  const hasChildren = item.children && item.children.length;

  return (
    <li>
      {<RenderLink item={item} idx={idx} />}
      {hasChildren && openDropdowns[idx] ? (
        <ul className={classes.navDropdown}>
          {item.children.map((child, idx2) => (
            <li key={idx2}>{<RenderLink item={child} idx={idx2} />}</li>
          ))}
        </ul>
      ) : null}
    </li>
  );
};

const styles = (theme) => {
  const hoverColor = Color(theme.colors.primary["500"])
    .darken(0.5)
    .string();
  return {
    navDropdown: {
      color: theme.colors.primaryFontColor,
      position: "static",
      float: "none",
      width: "auto",
      marginTop: "0",
      backgroundColor: "transparent",
      border: "0",
      display: "block",
      left: "15px",
      top: "90%",
      zIndex: theme.zIndex.tooltip,
      minWidth: "160px",
      padding: "5px 0",
      margin: "2px 0 0",
      fontSize: "14px",
      textAlign: "left",
      listStyle: "none",
      [theme.breakpoints(900)]: {
        position: "absolute",
        backgroundColor: theme.colors.primary["500"],
        float: "right",
        border: "1px solid rgba(0,0,0,.15)",
        borderRadius: theme.globalBorderRadius,
        boxShadow: "0 6px 12px rgba(0,0,0,.175)",
      },
      "& li a": {
        color: theme.colors.primaryFontColor,
        padding: "8px 16px",
        margin: "6px auto",
        lineHeight: "20px",
        display: "block",
        position: "relative",
        fontSize: "1em",
        "&:hover, &:focus": {
          textDecoration: "none",
          backgroundColor: hoverColor,
        },
      },
    },
  };
};

export default withGlobalContext(withStyles(styles)(RenderNavItem));
